import Overview from '../../components/Overview';
import { CustomerType } from '../../types';

type Props = {
  isLoadingConfig: boolean;
};

function GlobalView({ isLoadingConfig }: Props) {
  return (
    <Overview
      activeCustomerType={CustomerType.Commercial}
      isLoadingConfig={isLoadingConfig}
      viewType="global"
    />
  );
}

export default GlobalView;
